import { useContext } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./Routes";
import { Toaster } from "react-hot-toast";
import IntegracaoV1 from "shared/util/integrarFrontEndV1Functions";
import { LoadingContext } from "./context/LoadingContext";

const App: React.FC = () => {
  const { getDadosFromV1 } = IntegracaoV1();
  getDadosFromV1();

  const { isLoading } = useContext(LoadingContext);
  var Spinner = require("react-spinkit");
  document.title = "GROUP condomínios";

  const renderToastr = () => (
    <Toaster
      position="top-right"
      reverseOrder={false}
      gutter={8}
      containerClassName=""
      containerStyle={{ zIndex: 1000001 }}
      toastOptions={{
        // Define default options
        className: "",
        duration: 3000,
        style: {
          fontFamily: "FontAwesome",
          background: "#f8ac59",
          color: "#fff",
          padding: "10px",
          minWidth: "30vmin",
          maxWidth: "40vmin",
          minHeight: "10vmin",
          //fontSize: '24px',
          //lineHeight: '24px',
        },

        // Default options for specific types
        success: {
          style: {
            background: "#1ab394",
            color: "#fff",
          },
        },

        error: {
          style: {
            background: "#ed5565",
            color: "#fff",
          },
        },
      }}
    />
  );

  return (
    <div>
      <RouterProvider router={router} />
      {renderToastr()}
      {isLoading && (
        <div id="loading" className="spinner-parent">
          <Spinner className="custom-spinner-div" name="ball-spin-fade-loader" fadeIn="none" color="lightcyan" />
        </div>
      )}
    </div>
  );
};

export default App;
